import { Component, OnInit,ViewEncapsulation } from '@angular/core';
import { StoreService } from '../store.service';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Message, SelectItem, ConfirmationService } from 'primeng/primeng';
import { MenuItem } from 'primeng/api';
import {AutoCompleteModule} from 'primeng/autocomplete';

@Component({
  selector: 'app-doc-status',
  templateUrl: './doc-status.component.html',
  styleUrls: ['./doc-status.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [ApiService, ConfirmationService]
})
export class DocStatusComponent implements OnInit {

  activeIndex: number = 0;
  steps: MenuItem[];
  qboDocuments: any = [];
  msgs: Message[] = [];
  loadingMessage:any = "Loading...";
  text: string;

    
      
  

  constructor(private router: Router, private api: ApiService, private spinner: NgxSpinnerService, private ss: StoreService,
    private confirmationService: ConfirmationService) { }

  ngOnInit() {

    this.getDocuments();
    //this.bindSalesTax();
       
  }
  

 

getDocuments() {
  this.spinner.show();
  this.loadingMessage = "Getting Documents...";
  this.api.get('Scan/GetScanErrorDocument', '').subscribe(
    (res: {}) => this.success_getDocuments(res),
    error => this.failed_getDocuments(<any>error));
}
ReScanAll(){
  this.spinner.show();
  this.loadingMessage = "ReScanning All Documents...";
  this.api.post('Scan/ReScanAllDocument', this.qboDocuments).subscribe(
    (res: {}) => this.successReScanningAll(res),
    error => this.failedReScanningAll(<any>error));
}
ReScanDoc(hdr:any){
  this.loadingMessage = "ReScanning...";
  this.spinner.show();
     
  this.api.post('Scan/ScanQboDocument', hdr).subscribe(
    (res1: {}) => this.successReScanning(res1),
    error => this.failedReScanning(<any>error));
}
successReScanning(resp: any) {
  this.spinner.hide();
  this.msgs=[];
  this.msgs.push({ severity: 'success', summary: 'Success', detail: 'ReScanning Done Succesfully...' });
  this.getDocuments();
}

failedReScanning(resp: any) {
  this.spinner.hide();
  this.msgs=[];
    this.msgs.push({ severity: 'error', summary: 'Failed', detail: 'Please try again later...' });

}
successReScanningAll(resp: any) {
  this.spinner.hide();
  this.msgs=[];
  this.msgs.push({ severity: 'success', summary: 'Success', detail: 'ReScanning Done Succesfully...' });
  this.getDocuments();
}

failedReScanningAll(resp: any) {
  this.spinner.hide();
  this.msgs=[];
    this.msgs.push({ severity: 'error', summary: 'Failed', detail: 'Please try again later...' });

}
success_getDocuments(resp: any) {
  this.spinner.hide();
  
  this.qboDocuments=resp.Data;
}

failed_getDocuments(resp: any) {
  this.spinner.hide();
  this.msgs=[];
    this.msgs.push({ severity: 'error', summary: 'Failed', detail: 'Please try again later...' });

}

 
  
}